// This file is automatically generated. Do not edit manually.

import { Reclamation } from "src/api/generated/erp/db/types/tables/reclamation";
import { ReclamationCategory } from "src/api/generated/erp/db/types/tables/reclamationCategory";
import { ReclamationCause } from "src/api/generated/erp/db/types/tables/reclamationCause";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ReclamationFormApi {
	export async function getInitData(args: {
		reclamationId: number | null | undefined;
	}): Promise<ReclamationFormApi_InitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/reclamations/ReclamationForm/getInitData",
			method: "POST",
			data: {
				reclamationId: args.reclamationId,
			},
		});
		return response as ReclamationFormApi_InitData;
	}

	export async function save(args: { reclamation: Reclamation }): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/reclamations/ReclamationForm/save",
			method: "POST",
			data: {
				reclamation: args.reclamation,
			},
		});
		return response as number;
	}
}

export interface ReclamationFormApi_InitData {
	reclamation: Reclamation | null | undefined;
	reclamationCategories: Array<ReclamationCategory>;
	reclamationCauses: Array<ReclamationCause>;
}
